<template>
  <div class="d-flex w-100">
    <div v-if="!details" class="d-flex w-100">
      <div class="col-md-3">
        <templateFilter  @search="search" ></templateFilter>
      </div>
      <div class="col-md-9">
          <templateTable ref="tablesearchtemplate" @aprDetalhes="detalhesApr"></templateTable>
      </div>
    </div>
    <div v-if="details" class="d-flex w-100">
      <div class="col-md-3">
        <panelByApr ref="refPanelByApr" :aprId="aprId" :revisao="revisao" @AtualizaAbas="AtualizaAbas" :novoTemplateClonado="novoTemplateClonado"></panelByApr>
      </div>
      <div class="col-md-9">
        <tabsApr  @templateClonado="templateClonado" :aprId="aprId" :codigo="codigo" :revisao="revisao" @recarregarTemplateEdicao="recarregarTemplateEdicao" :statusTemplate="statusTemplate" :carregaAbas="atualizaAbasRevisao"></tabsApr>
      </div>
    </div>

  </div>
</template>

<script>
import templateApr from './templateApr'
export default templateApr
</script>

<style scoped>
 .col-md-3{
  padding-right: 0;
  padding-left: 0;
 }
</style>



// WEBPACK FOOTER //
// src/views/private/apr/templateApr/templateApr.vue